import { Injector, ModuleWithProviders, NgModule, inject } from '@angular/core';
import { StatusBarService } from './status-bar.service';
import { statusBarServiceFactory } from './status-bar-service.factory';
import { PlatformDetectionService } from '@libs/util/shared';
import { ColorCalculationsService } from '@libs/core/color';

@NgModule()
export class StatusBarModule {
  static injector: Injector;

  constructor() {
    const module = inject(StatusBarModule, { optional: true, skipSelf: true });
    const injector = inject(Injector);

    if (module) {
      throw new Error(`${StatusBarModule.name} should be imported only once!`);
    }

    StatusBarModule.injector = injector;
  }

  static forRoot(): ModuleWithProviders<StatusBarModule> {
    return {
      ngModule: StatusBarModule,
      providers: [
        {
          provide: StatusBarService,
          useFactory: statusBarServiceFactory,
          deps: [PlatformDetectionService, ColorCalculationsService],
        },
      ],
    };
  }
}
